module.exports = __webpack_public_path__ + "img/option_icon.6ff514c5.svg";